import showPhoneSystemFormModal from 'features/PhoneSystem/PhoneSystemFormModal'
import { connect } from 'react-redux'
import { PhoneSystemListComponent } from './PhoneSystemList'

const stateToProps = () => {
  return {}
}

export const dispatchToProps = {
  showPhoneSystemFormModal,
}

export const PhoneSystemList = connect(stateToProps, dispatchToProps)(PhoneSystemListComponent)



// WEBPACK FOOTER //
// src/features/PhoneSystem/PhoneSystemList/PhoneSystemList.container.ts